<div class="row col-12 justify-content-md-center">
	<form (ngSubmit)="reverseEvents()" class="col-md-6 col-sm-12">
		<h2>{{'action_log.reverse_events' | translate}}</h2>
		<div class="mb-3" *ngIf="isIMDevice">
			<p class="mb-1">{{'g.reverse_events_desc_title' | translate}}</p>
			<ul class="mb-0">
				<li>{{'g.reverse_events_desc_event_type' | translate}}</li>
				<li>{{'g.reverse_events_desc_energy' | translate}}</li>
				<li>{{'g.reverse_events_desc_peak_power' | translate}}</li>
				<li>{{'g.reverse_events_desc_duration' | translate}}</li>
				<li>{{'g.reverse_events_desc_kvarh' | translate}}</li>
				<li>{{'g.reverse_events_desc_historical' | translate}}</li>
			</ul>
		</div>
		<div class="form-field mb-2">
			<label for="start_id">{{'g.start_id' | translate}}</label>
			<input type='number' class='form-control' name="start_id" [(ngModel)]='startId'/>
		</div>
		<div class="form-field mb-2">
			<label for="end_id">{{'g.end_id' | translate}}</label>
			<input type='number' class='form-control' name="end_id" [(ngModel)]='endId'/>
		</div>
		<div class="my-4">
			<button type="submit" class="btn btn-primary">{{'g.reverse' | translate}}</button>
		</div>
	</form>
</div>